import { Chip } from '@mui/material';
import { FMT } from '../../../../../util/formatter-service';

/**
 * Read-only display of a company's native/reporting currency (Company.defaultCurrency).
 * Source of truth is Starbreaker/derivation, so this is never editable here.
 */
export function ReportingCurrencyChip({ currency }: { currency?: string | null }) {
  if (!currency) {
    return null;
  }
  return (
    <Chip
      aria-label={'reporting-currency'}
      size={'medium'}
      label={`Reporting: ${FMT.format('currencyCode', currency)}`}
      variant='outlined'
    />
  );
}
